import { EnhancedButtonPrimeReact, EnhancedButtonPrimeReactSeverity, LabelPosition, RHookFormNumberFieldWithLabel } from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";
import { Toolbar, useTheme } from "@mui/material";
import { provisionalVariableSInitialData, provisionalVariableSheaderColumns } from "../globalVariablesconstants";

import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { isEqual } from "lodash";

// import "./DataTableUI.css"






let emptyProvisionalVariableSStatus = {
  id: null,
  greaterThanA: null,
  lessThanEqualA: null,
  lessorOf1: null,
  lessorOf2: null,
};



interface IProvisionalVariableForNonQCSetupSDataTables {
  provisionalVariableSData: (data: any) => void;
  TableDataGetById: any
}
export const ProvisionalVariableForNonQCSetupSDataTables: FC<IProvisionalVariableForNonQCSetupSDataTables> = ({
  provisionalVariableSData,
  TableDataGetById
}) => {
  const theme = useTheme()
  const [provisionalVariableS, setProvisionalVariableS] = useState<any>(provisionalVariableSInitialData);
  const [selectedProvisionalVariableS, setSelectedProvisionalVariableS] = useState<any>(null);
  const [empStatus, setEmpStatus] = useState(emptyProvisionalVariableSStatus);

  useEffect(() => {
    if (TableDataGetById) {
      setProvisionalVariableS(TableDataGetById);
    }
     else {
      setProvisionalVariableS(provisionalVariableSInitialData)
    }
  }, [TableDataGetById]);

  useEffect(() => {
    if (!isEqual(provisionalVariableS, TableDataGetById)) {
      provisionalVariableSData([...provisionalVariableS]);
    }
  }, [provisionalVariableS]);

  // useEffect(() => {
  //   provisionalVariableSData(provisionalVariableS);
  // }, [provisionalVariableS]);



  const findIndexById = (id: string | number | any) => {
    let index = -1;

    for (let i = 0; i < provisionalVariableS.length; i++) {
      if (provisionalVariableS[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  };

  const createId = () => {
    let id = '';
    let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return id;
  };

  const openNew = () => {
    // alert("new")

    let _provisionalVariableS = [...provisionalVariableS];
    let _empStatus: any = { ...empStatus };

    if (empStatus.id) {
      const index = findIndexById(empStatus.id);

      _provisionalVariableS[index] = _empStatus;
    } else {
      _empStatus.id = createId();
      _provisionalVariableS.push(_empStatus);
    }



    setProvisionalVariableS(_provisionalVariableS);
    setEmpStatus(emptyProvisionalVariableSStatus);
  };
  const resetData = () => {
    setProvisionalVariableS(provisionalVariableSInitialData.map((item) => ({ id: item.id, item: null })));
    // setProvisionalVariableS(
    //   provisionalVariableSInitialData.map((item:any) => {
    //     const { id } = item;
    //     const resetItem = Object.fromEntries(
    //       Object.keys(item).map((key) => [key, key === "id" ? id : null])
    //     );
    //     return resetItem;
    //   })
    // );


    // setProvisionalVariableS(provisionalVariableSInitialData);

  };


  // const confirmDeleteSelected = () => {
  //   let _provisionalVariableS = provisionalVariableS.filter((val:any) => !selectedProvisionalVariableS.includes(val));
  //   setProvisionalVariableS(_provisionalVariableS);
  //   setSelectedProvisionalVariableS(null);
  // };

  // const onMoveUpClickHandler = () => {
  //   let newData = [...provisionalVariableS];
  //   const selectedIndices = selectedProvisionalVariableS.map((item:any) => 
  //     newData.findIndex((dataItem) => dataItem.id === item.id)
  //   );

  //   selectedIndices.forEach((index:any) => {
  //     if (index > 0) {
  //       [newData[index - 1], newData[index]] = [newData[index], newData[index - 1]];
  //     }
  //   });
  //   setProvisionalVariableS(newData);

  // };
  // const onMoveDownClickHandler = () => {
  //   let newData = [...provisionalVariableS];
  //   const selectedIndices = selectedProvisionalVariableS
  //     .map((item:any) => newData.findIndex((dataItem) => dataItem.id === item.id))
  //     .sort((a:any, b:any) => b - a); 

  //   selectedIndices.forEach((index:any) => {
  //     if (index < newData.length - 1) {
  //       [newData[index], newData[index + 1]] = [newData[index + 1], newData[index]];
  //     } 
  //   });
  //   setProvisionalVariableS(newData);

  // };

  // const onCellValueChange = (event: any, rowIndex: number, field: any) => {

  //   const updatedData = [...provisionalVariableS];


  //   updatedData[rowIndex][event.field] = field;

  //   // setProvisionalVariableS(updatedData);
  // };

  const onCellValueChange = (event: any, rowIndex: number, field: any) => {
    // setProvisionalVariableS((prev:any) => {
    //   const updatedData = [...prev];
    //   updatedData[rowIndex][event.field] = field;

    //   return updatedData;
    // });

    setProvisionalVariableS((prev: any) => {
      const updatedData = [...prev];
      const updatedRow = { ...updatedData[rowIndex], [event.field]: field };
      updatedData[rowIndex] = updatedRow;
      return updatedData;
    });
  };


  // const renderErrorClass = (field: any, rowIndex: number, rowData: any) => {
  //   if (field.field === "date") {
  //     if (rowData.status !== "" && rowData.status !== undefined && rowData.status !== null) {
  //       if(rowData.date === null){
  //         return "p-component p-filled calender-error-input"; 
  //       } else if(rowData.date === ""){
  //         return "p-component p-filled calender-error-input"; 
  //       }
  //     }
  //   } else {
  //     return "p-component p-filled input-dropdown-fields";
  //   }
  // };

  const columnsBody = (rowData: any, row: any, x: any) => {
    // if(x.field === 'notes'){
    //   return (
    //     <InputText
    //         value={rowData[x.field]}
    //         onChange={(e: any) =>
    //           onCellValueChange(x, row.rowIndex, e.target.value)
    //         }
    //         placeholder="Write notes here"
    //         className={renderErrorClass(x, row.rowIndex, rowData)}
    //       />
    //     )
    // }
    return (
      <InputNumber
        // inputId={`yoo-field`}
        value={rowData[x.field]}
        // onValueChange={(e: any) =>
        //             onCellValueChange(x, row.rowIndex, e.target.value)
        //           }
        onValueChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
        placeholder={"0.00"}
        minFractionDigits={2}
        maxFractionDigits={10}
        inputStyle={{
          textAlign: "right",
        }}
      // className={renderErrorClass(x, row.rowIndex, rowData)}
      />
    )
  }


  return (
    <>
      <div className="card">
        <Toolbar sx={{ justifyContent: "end", paddingRight: "0!important" }}>
          <>
            <EnhancedButtonPrimeReact
              label="Add"
              raised
              onClickHandler={openNew}
              style={{ marginLeft: "1rem" }}
              severity={EnhancedButtonPrimeReactSeverity.Secondary}
            />
            <EnhancedButtonPrimeReact
              label="Clear Data"
              raised
              onClickHandler={resetData}
              style={{ marginLeft: "1rem" }}
              severity={EnhancedButtonPrimeReactSeverity.Warning}
            />
          </>
        </Toolbar>
        <DataTable
          value={provisionalVariableS}
          // selection={selectedProvisionalVariableS} 
          // onSelectionChange={(e) => setSelectedProvisionalVariableS(e.value)}
          dataKey="id"
          showGridlines
          className="DataTableUI"
          editMode="cell"
          resizableColumns
          columnResizeMode="expand"
          scrollable
          // reorderableColumns
          filterDisplay="menu"
          // selectionMode="checkbox"
          scrollHeight="516px"
        >
          {/* <Column
                      selectionMode="multiple"
                      // hidden={!showChecboxColumn}
                      frozen={true}
                      resizeable={false}
                      style={{ 
                        width: "36px",
                        textAlign: "center",
                        // zIndex:1,
                        borderRight:"1px solid #e5e7eb",
                        top:0
                       }}
                      field="selection"
                      columnKey="selection"
                      className="selectionHeader"
                      // headerStyle={{zIndex:'2!important'}}
                    /> */}
          {provisionalVariableSheaderColumns.map((x: any, index: any) => {
            return (
              <Column
                key={index}
                field={x.field}
                header={x.headerName}
                headerTooltip={x.description}
                headerTooltipOptions={{ position: "top" }}
                // sortable={false}
                // resizeable={x.resizable}
                // dataType={x.type}
                align={x.align}
                alignHeader={x.headerAlign}
                // reorderable={x.disableReorder}
                // exportable={x.disableExport}
                frozen={x.frozenColumn}
                columnKey={x.field}
                style={{
                  width: x.minWidth,
                  fontSize: "0.875rem",
                }}
                footer={x.footer}
                body={(rowData: any, row: any) => columnsBody(rowData, row, x)}
              />
            );
          })}
        </DataTable>
      </div>
    </>
  );
};
